<template>
  <div class="taskDispatch">
    <el-form :inline="true">
      <el-row>
        <el-form-item label="区县名称：">
          <el-input v-model="query.townName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addFunc">+ 新增</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-table :data="list" border style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        width="55px"
        align="center"></el-table-column>
      <el-table-column
        prop="townCode"
        label="区县编码"
        align="center"></el-table-column>
      <el-table-column
        prop="townName"
        label="区县名称"
        align="center"></el-table-column>
      <el-table-column
        prop="parentCode"
        label="父级编码"
        align="center"></el-table-column>
      <el-table-column label="操作" width="100px" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="medium" @click="editFunc(scope.row)">
            编辑
          </el-button>
          <el-button type="text" size="medium" @click="deleteFunc(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false">
      <el-form :model="dialgForm" ref="dialgForm" label-width="120px">
        <el-form-item label="父级编码" prop="parentCode">
          <el-input v-model="dialgForm.parentCode"></el-input>
        </el-form-item>
        <el-form-item label="区县编码" prop="townCode">
          <el-input v-model="dialgForm.townCode"></el-input>
        </el-form-item>
        <el-form-item label="区县名称" prop="townName">
          <el-input v-model="dialgForm.townName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ensureClick()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchList, addOrEdit, delStreet, detail } from '@/api/street'
export default {
  name: 'TaskDispatch',
  data() {
    return {
      list: [],
      total: 0,
      query: {
        current: 0,
        size: 10,
        townCode: '',
        townName: ''
      },

      dialgForm: {
        parentCode: '',
        townCode: '',
        townName: ''
      },

      dialogVisible: false,
      dialogTitle: ''
    }
  },
  created(){
    this.searchList()
  },
  methods: {
    // 重置表单
    restDialogFormHandle() {
      this.dialgForm = {
        parentCode: '',
        townCode: '',
        townName: ''
      }
    },

    ensureClick() {
      this.addOrEdit()
    },

    async addOrEdit() {
      const result = await addOrEdit(this.dialgForm)
      if (result.data.code === 200) {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.dialogVisible = false
        this.searchList()
        this.restDialogFormHandle()
      }
    },

    addFunc() {
      this.dialogVisible = true
      this.dialogTitle = '新增'
    },
    editFunc(row) {
      Object.assign(this.dialgForm, row)
      this.dialogVisible = true
      // this.detailFrom(row)
    },

    async detailFrom(row) {
      const { data } = await detail(row.townCode)
      if (data.code === 200) {
        this.dialgForm = data.data
        this.dialogVisible = true
        this.dialogTitle = '编辑'
      } else {
        this.$message({
          type: 'error',
          message: data.message
        })
      }
    },

    deleteFunc(row) {
      this.$confirm('确定删除该部门？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteDept(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    deleteDept(row) {
      delStreet({townCode:row.townCode}).then(res => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.searchList()
        }
      })
    },

    async searchList() {
      const { data } = await searchList(this.query)
      if (data.code === 200) {
        this.list = data.data.records
        this.total = data.data.total
      }
    },
    goToDetail(row) {
      this.$router.push('/projectDetail?id=' + row.projectId)
    },
    handleCurrentChange(val) {
      this.query.current = val
      this.searchList()
    },
    handleSizeChange(val) {
      this.query.size = val
      this.query.current = 0
      this.searchList()
    }
  }
}
</script>

<style lang="scss" scoped>
.taskDispatch {
  padding: 20px;
}
</style>
